<div>
  <breadcrumbs
    [customBreadcrumbs]="customBreadcrumb ? customBreadcrumb : undefined"
    (customBreadcrumbClick)="breadcrumbClick.emit($event)"
  ></breadcrumbs>

  <div class="rv-title-05 current-breadcrumb" [phi]="titlePhi">
    <a *ngIf="href" class="rv-link" [href]="href" [target]="target">
      {{ title }}
    </a>
    <div *ngIf="!href">
      {{ title }}
    </div>
  </div>
</div>
